import React, { useState } from "react";

import { CSVLink } from "react-csv";

import { useEjectionReportsContext } from "../contexts/EjectionReports";
import { CSVData } from "../types/games";

import { defaultDateTimeFormat } from "../../../../lib/utils";
import { IEjectionReport, IGame } from "../../../../types/api";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { selectAllSites } from "../../../../features/global/globalSlice";
import { getNameOfEjected } from "../lib/getNameOfEjected";

const DownloadButton = ({ site }: { site?: string }): React.JSX.Element => {
    const { reports } = useEjectionReportsContext();
    const sites = useAppSelector(selectAllSites);

    const [csvData, setCSVData] = useState<Array<CSVData>>([]);
    const CSVHeaders = [
        { label: "Date", key: "date" },
        { label: "Site", key: "site" },
        { label: "Teams", key: "teams" },
        { label: "Name of Ejected", key: "ejected" },
        { label: "Umpire", key: "umpire" },
        { label: "Report", key: "report" },
    ];

    const generateCSVRow = (r: IEjectionReport): CSVData => {
        return {
            date: defaultDateTimeFormat.format(new Date(r.date)),
            site: sites.find(s => r.site === s.id)?.displayName,
            teams: `${r.visitor.name || "TBD"} @ ${r.home.name || "TBD"}`,
            ejected: getNameOfEjected(r),
            umpire: r.umpires?.find(u => u.id === r.userId)?.name,
            report: r.report,
        };
    };

    const handleDownload = () => {
        const CSVData = reports.map(r => generateCSVRow(r));
        setCSVData(CSVData);
    };

    return (
        <CSVLink
            data={csvData}
            headers={CSVHeaders}
            filename={`EjectionReports-UmpHub.${new Date().getTime()}.csv`}
            className="btn btn-primary"
            target="_blank"
            onClick={handleDownload}
        >
            Download Excel File
        </CSVLink>
    );
};

export default DownloadButton;
